import React from 'react';

import { Button } from '@trqk/components';
import { locale, getFilenameFromPath } from '@trqk/utils';

import iconUrl from '../../../assets/svg/insights-empty-gap-analysis.svg';

export const GapAnalysisDownloadReady = ({
    remove,
    input,
}: ToastRenderContentProps<{
    reportUrl: string;
    gapAnalysisId: string;
    gapSummary: Maybe<TrqkGapSummary>;
}>): JSX.Element => {
    const reportUrl = input?.reportUrl ?? null;
    const gapAnalysisId = input?.gapAnalysisId ?? null;
    const description = input?.gapSummary?.description ?? null;
    const descriptionNoWhitespace = description
        ? description.replace(/\s/gi, '_')
        : null;
    const defaultFilename = `${
        descriptionNoWhitespace ??
        `${
            locale.enUS.TOASTS.GAP_ANALYSIS_DOWNLOAD_READY.DEFAULT_REPORT_NAME
        }.${Date.now()}`
    }.zip`;

    const filename =
        reportUrl !== null ? getFilenameFromPath(reportUrl) : defaultFilename;

    return (
        <div className="px-2" style={{ width: 400 }}>
            <div className="mb-6 font-medium">
                {locale.enUS.TOASTS.GAP_ANALYSIS_DOWNLOAD_READY.REPORT_IS_READY}
            </div>
            <div className="flex items-center mb-6">
                <img src={iconUrl} width={24} alt="Gap Analysis icon" />
                <p className="ml-2 text-sm break-all">{filename}</p>
            </div>
            <div className="mb-2">
                {reportUrl && gapAnalysisId && (
                    <a
                        className="px-2"
                        href={reportUrl}
                        download={filename}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Button
                            autoWidth={true}
                            color="primary-light-bg"
                            handleClick={() => {
                                remove();
                            }}
                        >
                            {
                                locale.enUS.TOASTS.GAP_ANALYSIS_DOWNLOAD_READY
                                    .DOWNLOAD_REPORT
                            }
                        </Button>
                    </a>
                )}
            </div>
        </div>
    );
};
